import { CheckIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const StepperComponent = () => {
  const [params, _setParams] = useSearchParams();
  const page_step = params.get("page_step");
  const coupon_id = params.get("coupon_id");
  const navigate = useNavigate();

  const [steps, setSteps] = useState([
    { id: "details_and_schedule", name: "Details & Schedule", status: "upcoming" },
    { id: "applicable_conditions", name: "Applicability Conditions", status: "upcoming" },
    { id: "discount_page", name: "Discount Type", status: "upcoming" },
    { id: "usage_details", name: "Usage Limits", status: "upcoming" },
  ]);

  // Update step status based on page_step from URL
  useEffect(() => {
    const currentStepIndex = steps.findIndex((step) => step.id === page_step);

    const updatedSteps = steps.map((step, index) => {
      if (index < currentStepIndex) {
        return { ...step, status: "complete" };
      } else if (index === currentStepIndex) {
        return { ...step, status: "current" };
      } else {
        return { ...step, status: "upcoming" };
      }
    });

    setSteps(updatedSteps);
  }, [page_step]);

  const handelStepperMovment = (page_step: string, stepStatus: string, currentStepIndex: number) => {
    // if (stepStatus === "complete" || steps[currentStepIndex - 1]?.status === "complete") {
    //   navigate(`/app/coupon-service/coupon-creation?page_step=${page_step}`);
    // }
    // navigate(`/app/coupon-service/coupon-creation?page_step=${page_step}&&coupon_id=${coupon_id}`);
  };

  return (
    <nav aria-label="Progress" className="py-4 mt-2">
      {/* Desktop Stepper */}
      <div className="hidden md:block">
        <ol role="list" className="flex items-center w-full">
          {steps.map((step, index) => {
            const isCompleted = step.status === "complete";
            const isCurrent = step.status === "current";
            const isUpcoming = step.status === "upcoming";
            const isLast = index === steps.length - 1;

            return (
              <li
                key={step.name}
                className={`flex items-center ${!isLast ? "flex-grow" : ""}`}
              >
                <div
                  onClick={() => handelStepperMovment(step.id, step.status, index)}
                  className="flex items-center gap-3 cursor-pointer group"
                >
                  {/* Circle */}
                  <div className="relative flex-shrink-0">
                    {isCompleted ? (
                      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#4D9FFF] text-white shadow-sm transition-all duration-300 group-hover:bg-[#3b8ee6]">
                        <CheckIcon aria-hidden="true" className="h-4 w-4 stroke-[3]" />
                      </div>
                    ) : isCurrent ? (
                      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-[#4D9FFF] bg-white ring-4 ring-[#4D9FFF]/15 shadow-sm transition-all duration-300">
                        <div className="h-2.5 w-2.5 rounded-full bg-[#4D9FFF] animate-pulse" />
                      </div>
                    ) : (
                      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white transition-all duration-300 group-hover:border-gray-400">
                        <div className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-200" />
                      </div>
                    )}
                  </div>

                  {/* Label */}
                  <span
                    className={`text-sm font-semibold tracking-wide transition-colors duration-300 ${isCurrent
                      ? "text-[#1A1F36] font-bold"
                      : isCompleted
                        ? "text-[#4F566B] font-medium group-hover:text-[#1A1F36]"
                        : "text-[#A3ACBF] font-medium group-hover:text-[#4F566B]"
                      }`}
                  >
                    {step.name}
                  </span>
                </div>
                {!isLast && (
                  <div className="h-[2px] flex-grow mx-4 rounded-full bg-gray-200 overflow-hidden min-w-[2rem]">
                    <div
                      className={`h-full bg-[#4D9FFF] transition-all duration-500 ${isCompleted ? "w-full" : "w-0"
                        }`}
                    />
                  </div>
                )}
              </li>
            );
          })}
        </ol>
      </div>
      <div className="block md:hidden px-1">
        <ol role="list" className="relative space-y-4">
          {steps.map((step, index) => {
            const isCompleted = step.status === "complete";
            const isCurrent = step.status === "current";
            const isUpcoming = step.status === "upcoming";
            const isLast = index === steps.length - 1;

            return (
              <li
                key={step.name}
                className="relative flex items-center gap-4 cursor-pointer group"
                onClick={() => handelStepperMovment(step.id, step.status, index)}
              >
                {!isLast && (
                  <div
                    className="absolute top-8 left-[15px] bottom-[-16px] w-[2px] bg-gray-200"
                    aria-hidden="true"
                  >
                    <div
                      className={`h-full bg-[#4D9FFF] transition-all duration-500 ${isCompleted ? "h-full" : "h-0"
                        }`}
                    />
                  </div>
                )}

                {/* Circle */}
                <div className="relative flex-shrink-0 z-10">
                  {isCompleted ? (
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#4D9FFF] text-white shadow-sm transition-all duration-300 group-hover:bg-[#3b8ee6]">
                      <CheckIcon aria-hidden="true" className="h-4 w-4 stroke-[3]" />
                    </div>
                  ) : isCurrent ? (
                    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-[#4D9FFF] bg-white ring-4 ring-[#4D9FFF]/15 shadow-sm transition-all duration-300">
                      <div className="h-2.5 w-2.5 rounded-full bg-[#4D9FFF] animate-pulse" />
                    </div>
                  ) : (
                    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white transition-all duration-300 group-hover:border-gray-400">
                      <div className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-200" />
                    </div>
                  )}
                </div>

                {/* Label */}
                <div className="flex flex-col">
                  <span
                    className={`text-sm font-semibold tracking-wide transition-colors duration-300 ${isCurrent
                      ? "text-[#1A1F36] font-bold"
                      : isCompleted
                        ? "text-[#4F566B] font-medium group-hover:text-[#1A1F36]"
                        : "text-[#A3ACBF] font-medium group-hover:text-[#4F566B]"
                      }`}
                  >
                    {step.name}
                  </span>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default StepperComponent;
